// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Scalar from "../../core/Scalar.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as DeviceName from "../Device/DeviceName.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as ShowAllDataLink from "../../resources/navigation/ShowAllDataLink.res.js";
import * as StockActivityKind from "../StockActivity/StockActivityKind.res.js";
import * as TableDatetimeCell from "../../resources/tables/TableDatetimeCell.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as StockActivityTypeTableCell from "../StockActivity/StockActivityTypeTableCell.res.js";
import * as StockActivitySourceTableCell from "../StockActivity/StockActivitySourceTableCell.res.js";
import * as StockActivityQuantityTableCell from "../StockActivity/StockActivityQuantityTableCell.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query stockActivitiesByVariantCku($cku: CKU!, $first: Int, $filterBy: InputStockActivitiesQueryFilter)  {\nstockActivitiesByVariantCku(cku: $cku, first: $first, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nkind  \nreason  \ncomment  \nshop  {\n__typename  \nname  \n}\n\ndevice  {\n__typename  \nname  \nslug  \n}\n\ncreatedAt  \nquantity  \nvariant  {\n__typename  \nid  \ncku  \nbulk  \ncapacityPrecision  \ncapacityUnit  \nproduct  {\n__typename  \nid  \ncolor  \n}\n\n}\n\n}\n\n}\n\npageInfo  {\n__typename  \nhasNextPage  \n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.stockActivitiesByVariantCku;
  let value$2 = value$1.edges;
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  return {
    stockActivitiesByVariantCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.kind;
        let tmp;
        switch (value$2) {
          case "CREDIT_MEMO" :
            tmp = "CREDIT_MEMO";
            break;
          case "DELIVERY" :
            tmp = "DELIVERY";
            break;
          case "DELIVERY_RECEIPT" :
            tmp = "DELIVERY_RECEIPT";
            break;
          case "INCOMING_TRANSFER" :
            tmp = "INCOMING_TRANSFER";
            break;
          case "LOSS" :
            tmp = "LOSS";
            break;
          case "OUTGOING_TRANSFER" :
            tmp = "OUTGOING_TRANSFER";
            break;
          case "RECEPTION" :
            tmp = "RECEPTION";
            break;
          case "REFUND" :
            tmp = "REFUND";
            break;
          case "RESET" :
            tmp = "RESET";
            break;
          case "SALE" :
            tmp = "SALE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$3 = value$1.reason;
        let tmp$1;
        if (value$3 == null) {
          tmp$1 = undefined;
        } else {
          let tmp$2;
          switch (value$3) {
            case "CORKY" :
              tmp$2 = "CORKY";
              break;
            case "DAMAGE" :
              tmp$2 = "DAMAGE";
              break;
            case "LOSS" :
              tmp$2 = "LOSS";
              break;
            case "OTHER" :
              tmp$2 = "OTHER";
              break;
            case "OUTDATED_DLUO" :
              tmp$2 = "OUTDATED_DLUO";
              break;
            case "SALE_BY_GLASS" :
              tmp$2 = "SALE_BY_GLASS";
              break;
            case "TASTING" :
              tmp$2 = "TASTING";
              break;
            case "THEFT" :
              tmp$2 = "THEFT";
              break;
            case "TRADE_IN_SUPPLIER" :
              tmp$2 = "TRADE_IN_SUPPLIER";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = tmp$2;
        }
        let value$4 = value$1.comment;
        let value$5 = value$1.shop;
        let value$6 = value$1.device;
        let value$7 = value$1.variant;
        let tmp$3;
        if (value$7 == null) {
          tmp$3 = undefined;
        } else {
          let value$8 = value$7.bulk;
          let value$9 = value$7.capacityPrecision;
          let value$10 = value$7.capacityUnit;
          let value$11 = value$7.product;
          let value$12 = value$11.color;
          let tmp$4;
          if (value$12 == null) {
            tmp$4 = undefined;
          } else {
            let tmp$5;
            switch (value$12) {
              case "AMBER" :
                tmp$5 = "AMBER";
                break;
              case "BLACK" :
                tmp$5 = "BLACK";
                break;
              case "BLOND" :
                tmp$5 = "BLOND";
                break;
              case "DARK" :
                tmp$5 = "DARK";
                break;
              case "ORANGE" :
                tmp$5 = "ORANGE";
                break;
              case "RED" :
                tmp$5 = "RED";
                break;
              case "ROSE" :
                tmp$5 = "ROSE";
                break;
              case "WHITE" :
                tmp$5 = "WHITE";
                break;
              default:
                throw {
                  RE_EXN_ID: "Not_found",
                  Error: new Error()
                };
            }
            tmp$4 = tmp$5;
          }
          tmp$3 = {
            __typename: value$7.__typename,
            id: value$7.id,
            cku: Scalar.CKU.parse(value$7.cku),
            bulk: !(value$8 == null) ? value$8 : undefined,
            capacityPrecision: !(value$9 == null) ? value$9 : undefined,
            capacityUnit: !(value$10 == null) ? value$10 : undefined,
            product: {
              __typename: value$11.__typename,
              id: value$11.id,
              color: tmp$4
            }
          };
        }
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            kind: tmp,
            reason: tmp$1,
            comment: !(value$4 == null) ? Scalar.Text.parse(value$4) : undefined,
            shop: {
              __typename: value$5.__typename,
              name: value$5.name
            },
            device: {
              __typename: value$6.__typename,
              name: value$6.name,
              slug: value$6.slug
            },
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            quantity: value$1.quantity,
            variant: tmp$3
          }
        };
      }),
      pageInfo: {
        __typename: value$3.__typename,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      }
    }
  };
}

function serialize(value) {
  let value$1 = value.stockActivitiesByVariantCku;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.hasNextPage;
  let hasNextPage = value$3 !== undefined ? value$3 : null;
  let value$4 = value$2.__typename;
  let pageInfo = {
    __typename: value$4,
    hasNextPage: hasNextPage
  };
  let value$5 = value$1.edges;
  let edges = value$5.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.variant;
    let variant;
    if (value$2 !== undefined) {
      let value$3 = value$2.product;
      let value$4 = value$3.color;
      let color = value$4 !== undefined ? (
          value$4 === "ORANGE" ? "ORANGE" : (
              value$4 === "RED" ? "RED" : (
                  value$4 === "AMBER" ? "AMBER" : (
                      value$4 === "DARK" ? "DARK" : (
                          value$4 === "BLACK" ? "BLACK" : (
                              value$4 === "BLOND" ? "BLOND" : (
                                  value$4 === "ROSE" ? "ROSE" : "WHITE"
                                )
                            )
                        )
                    )
                )
            )
        ) : null;
      let value$5 = value$3.id;
      let value$6 = value$3.__typename;
      let product = {
        __typename: value$6,
        id: value$5,
        color: color
      };
      let value$7 = value$2.capacityUnit;
      let capacityUnit = value$7 !== undefined ? value$7 : null;
      let value$8 = value$2.capacityPrecision;
      let capacityPrecision = value$8 !== undefined ? value$8 : null;
      let value$9 = value$2.bulk;
      let bulk = value$9 !== undefined ? value$9 : null;
      let value$10 = value$2.cku;
      let value$11 = Scalar.CKU.serialize(value$10);
      let value$12 = value$2.id;
      let value$13 = value$2.__typename;
      variant = {
        __typename: value$13,
        id: value$12,
        cku: value$11,
        bulk: bulk,
        capacityPrecision: capacityPrecision,
        capacityUnit: capacityUnit,
        product: product
      };
    } else {
      variant = null;
    }
    let value$14 = value$1.quantity;
    let value$15 = value$1.createdAt;
    let value$16 = Scalar.Datetime.serialize(value$15);
    let value$17 = value$1.device;
    let value$18 = value$17.slug;
    let value$19 = value$17.name;
    let value$20 = value$17.__typename;
    let device = {
      __typename: value$20,
      name: value$19,
      slug: value$18
    };
    let value$21 = value$1.shop;
    let value$22 = value$21.name;
    let value$23 = value$21.__typename;
    let shop = {
      __typename: value$23,
      name: value$22
    };
    let value$24 = value$1.comment;
    let comment = value$24 !== undefined ? Scalar.Text.serialize(value$24) : null;
    let value$25 = value$1.reason;
    let reason = value$25 !== undefined ? (
        value$25 === "DAMAGE" ? "DAMAGE" : (
            value$25 === "OUTDATED_DLUO" ? "OUTDATED_DLUO" : (
                value$25 === "SALE_BY_GLASS" ? "SALE_BY_GLASS" : (
                    value$25 === "THEFT" ? "THEFT" : (
                        value$25 === "TASTING" ? "TASTING" : (
                            value$25 === "LOSS" ? "LOSS" : (
                                value$25 === "OTHER" ? "OTHER" : (
                                    value$25 === "TRADE_IN_SUPPLIER" ? "TRADE_IN_SUPPLIER" : "CORKY"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    let value$26 = value$1.kind;
    let kind = value$26 === "DELIVERY_RECEIPT" ? "DELIVERY_RECEIPT" : (
        value$26 === "RESET" ? "RESET" : (
            value$26 === "INCOMING_TRANSFER" ? "INCOMING_TRANSFER" : (
                value$26 === "DELIVERY" ? "DELIVERY" : (
                    value$26 === "REFUND" ? "REFUND" : (
                        value$26 === "LOSS" ? "LOSS" : (
                            value$26 === "CREDIT_MEMO" ? "CREDIT_MEMO" : (
                                value$26 === "SALE" ? "SALE" : (
                                    value$26 === "RECEPTION" ? "RECEPTION" : "OUTGOING_TRANSFER"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      );
    let value$27 = value$1.id;
    let value$28 = value$1.__typename;
    let node = {
      __typename: value$28,
      id: value$27,
      kind: kind,
      reason: reason,
      comment: comment,
      shop: shop,
      device: device,
      createdAt: value$16,
      quantity: value$14,
      variant: variant
    };
    let value$29 = value.__typename;
    return {
      __typename: value$29,
      node: node
    };
  });
  let value$6 = value$1.__typename;
  let stockActivitiesByVariantCku = {
    __typename: value$6,
    edges: edges,
    pageInfo: pageInfo
  };
  return {
    stockActivitiesByVariantCku: stockActivitiesByVariantCku
  };
}

function serializeInputObjectInOrNotInFilter(inp) {
  let a = inp._in;
  let a$1 = inp._notIn;
  return {
    _in: a !== undefined ? a.map(b => b) : undefined,
    _notIn: a$1 !== undefined ? a$1.map(b => b) : undefined
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInputStockActivitiesQueryFilter(inp) {
  let a = inp.kind;
  let a$1 = inp.reason;
  let a$2 = inp.date;
  let a$3 = inp.shopIds;
  return {
    kind: a !== undefined ? serializeInputObjectInOrNotInFilter(a) : undefined,
    reason: a$1 !== undefined ? serializeInputObjectInFilter(a$1) : undefined,
    date: a$2 !== undefined ? serializeInputObjectDateFilter(a$2) : undefined,
    shopIds: a$3 !== undefined ? serializeInputObjectInFilter(a$3) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.first;
  let a$1 = inp.filterBy;
  return {
    cku: inp.cku,
    first: a !== undefined ? a : undefined,
    filterBy: a$1 !== undefined ? serializeInputObjectInputStockActivitiesQueryFilter(a$1) : undefined
  };
}

function makeVariables(cku, first, filterBy, param) {
  return {
    cku: cku,
    first: first,
    filterBy: filterBy
  };
}

function makeInputObjectInputStockActivitiesQueryFilter(kind, reason, date, shopIds, param) {
  return {
    kind: kind,
    reason: reason,
    date: date,
    shopIds: shopIds
  };
}

function makeInputObjectInOrNotInFilter(_in, _notIn, param) {
  return {
    _in: _in,
    _notIn: _notIn
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

let StockActivitiesQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputStockActivitiesQueryFilter: serializeInputObjectInputStockActivitiesQueryFilter,
  serializeInputObjectInOrNotInFilter: serializeInputObjectInOrNotInFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables,
  makeInputObjectInputStockActivitiesQueryFilter: makeInputObjectInputStockActivitiesQueryFilter,
  makeInputObjectInOrNotInFilter: makeInputObjectInOrNotInFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let useLazy = include.useLazy;

let StockActivitiesQuery_refetchQueryDescription = include.refetchQueryDescription;

let StockActivitiesQuery_use = include.use;

let StockActivitiesQuery_useLazyWithVariables = include.useLazyWithVariables;

let StockActivitiesQuery = {
  StockActivitiesQuery_inner: StockActivitiesQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputStockActivitiesQueryFilter: serializeInputObjectInputStockActivitiesQueryFilter,
  serializeInputObjectInOrNotInFilter: serializeInputObjectInOrNotInFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables,
  makeInputObjectInputStockActivitiesQueryFilter: makeInputObjectInputStockActivitiesQueryFilter,
  makeInputObjectInOrNotInFilter: makeInputObjectInOrNotInFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  refetchQueryDescription: StockActivitiesQuery_refetchQueryDescription,
  use: StockActivitiesQuery_use,
  useLazy: useLazy,
  useLazyWithVariables: StockActivitiesQuery_useLazyWithVariables
};

function keyExtractor(row) {
  return row.id + "-activity";
}

let Row = {
  keyExtractor: keyExtractor
};

let columns = [
  {
    key: "activity-type",
    name: I18n.t("Type"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 130
      },
      width: {
        NAME: "fr",
        VAL: 1
      }
    },
    render: param => {
      let match = param.data;
      return JsxRuntime.jsx(StockActivityTypeTableCell.make, {
        value: match.formattedKind,
        reason: match.reason
      });
    }
  },
  {
    key: "activity-quantity",
    name: I18n.t("Quantity"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 70
      },
      width: {
        NAME: "fr",
        VAL: 1
      },
      alignX: "center"
    },
    render: param => {
      let match = param.data;
      return JsxRuntime.jsx(StockActivityQuantityTableCell.make, {
        value: match.quantity,
        capacityPrecision: match.variantCapacityPrecision,
        capacityUnit: match.variantCapacityUnit,
        kind: match.kind
      });
    }
  },
  {
    key: "activity-description",
    name: I18n.t("Comment"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 130
      },
      width: {
        NAME: "fr",
        VAL: 1.5
      },
      margin: "normal"
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: Stdlib_Option.getOr(param.data.description, "—")
    })
  },
  {
    key: "activity-datetime",
    name: I18n.t("Datetime"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 110
      }
    },
    render: param => JsxRuntime.jsx(TableDatetimeCell.make, {
      value: param.data.date
    })
  },
  {
    key: "activity-source",
    name: I18n.t("Source"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 150
      }
    },
    render: param => {
      let match = param.data;
      return JsxRuntime.jsx(StockActivitySourceTableCell.make, {
        deviceName: match.deviceName,
        shopName: match.shopName
      });
    }
  }
];

function CatalogVariantStockActivityTableCard(props) {
  let cku = props.cku;
  let match = useLazy(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let queryResults = match[1];
  let executeQuery = match[0];
  let activeShop = Auth.useActiveShop();
  let activeShopId = Stdlib_Option.map(activeShop, shop => shop.id);
  let match$1 = Navigation.useUrl();
  React.useEffect(() => {
    executeQuery(undefined, undefined, {
      cku: Scalar.CKU.serialize(cku),
      first: 5,
      filterBy: makeInputObjectInputStockActivitiesQueryFilter(undefined, undefined, undefined, activeShopId !== undefined ? ({
          _in: [activeShopId]
        }) : undefined, undefined)
    });
  }, [activeShopId]);
  let tmp;
  if (queryResults.TAG === "Executed") {
    let match$2 = queryResults._0;
    let match$3 = match$2.data;
    if (match$3 !== undefined) {
      let match$4 = match$3.stockActivitiesByVariantCku;
      let rows = Stdlib_Array.filterMap(match$4.edges, param => {
        let node = param.node;
        let variant = node.variant;
        if (variant === undefined) {
          return;
        }
        let match = variant.bulk;
        let match$1 = variant.capacityPrecision;
        let match$2 = variant.bulk;
        let match$3 = variant.capacityUnit;
        return {
          id: node.id,
          formattedKind: StockActivityKind.toLabel(node.kind),
          kind: node.kind,
          reason: node.reason,
          quantity: node.quantity,
          variantCapacityPrecision: match !== undefined && match && match$1 !== undefined ? match$1 : undefined,
          variantCapacityUnit: match$2 !== undefined && match$2 && match$3 !== undefined ? match$3 : undefined,
          description: node.comment,
          date: node.createdAt,
          shopName: node.shop.name,
          deviceName: DeviceName.format(DeviceName.decode(node.device.slug, node.device.name))
        };
      });
      let placeholderEmptyState = JsxRuntime.jsx(Placeholder.make, {
        status: "NoDataAvailable",
        customText: I18n.t("No stock activity has been yet recorded"),
        compact: true
      });
      let data = {
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: rows
        }
      };
      tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx(TableView.make, {
            data: data,
            columns: columns,
            keyExtractor: keyExtractor,
            placeholderEmptyState: placeholderEmptyState
          }),
          match$4.pageInfo.hasNextPage === true ? JsxRuntime.jsx(ShowAllDataLink.make, {
              href: match$1.pathname + "/stockactivities"
            }) : null
        ]
      });
    } else {
      tmp = match$2.loading ? JsxRuntime.jsx(Placeholder.make, {
          status: "Loading"
        }) : JsxRuntime.jsx(Placeholder.make, {
          status: "Error"
        });
    }
  } else {
    tmp = JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
  return JsxRuntime.jsx(Card.make, {
    children: tmp,
    title: I18n.t("Stock activities"),
    variation: "table"
  });
}

let make = React.memo(CatalogVariantStockActivityTableCard);

let edgesPerFetch = 5;

export {
  edgesPerFetch,
  StockActivitiesQuery,
  Row,
  columns,
  make,
}
/* query Not a pure module */
